var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 45 45","preserveAspectRatio":""}},[_c('g',{attrs:{"fill":"currentColor","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M10 15h25v1H10zM10 22h25v1H10zM10 29h25v1H10z"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }